/* Componente interno al drawer per la creazione della Toc */

import React from 'react';
import tocImage from './list.svg'
import CloseIcon from '@material-ui/icons/Close';
import './TocComponent.css'
import { Trans } from 'react-i18next';
import ListToc from '../TocComponent/List/ListToc'
import { useTranslation } from 'react-i18next';


export default function TocComponent(props) {
  
  useTranslation()
  return (
        <div className={"lateraltDiv"}>
          <div className={"title"}>
            <img src={tocImage} alt="Calcolo" className={"tocImage"}></img><Trans>TOC</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button></div>
  
            <ListToc data={props.data}/>
        </div>

  );
}